import React from 'react';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';

import {
  TypographyMessageText as TypographyMessageTextComp,
  TypographyMessageTextProps as TypographyMessageTextCompProps,
} from 'embeds/components';

import { TypographyMessageText_EmbedMessage$key } from './__generated__/TypographyMessageText_EmbedMessage.graphql';

export interface TypographyMessageTextProps extends Omit<TypographyMessageTextCompProps, 'classes' | 'messageText'> {
  fragmentRef: TypographyMessageText_EmbedMessage$key;
}

const TypographyMessageText: React.FC<TypographyMessageTextProps> = ({ fragmentRef, ...rest }) => {
  const message = useFragment<TypographyMessageText_EmbedMessage$key>(
    graphql`
      fragment TypographyMessageText_EmbedMessage on Message {
        text
      }
    `,
    fragmentRef,
  );

  return <TypographyMessageTextComp messageText={message.text || ''} {...rest} />;
};

export default TypographyMessageText;
